// TelcoTrack — Navolávání: zbývající kapacita k navolání / rezervaci podle druhu práce.

import {
  NAVOLAVANI_WORK_KINDS,
  workQueueTabForReservationKind,
  type NavolavaniWorkKind,
  type WorkReservationKind,
} from '../constants/work-reservation.constants';
import {
  isWorkQueueBuildingMatch,
  type WorkQueueBuildingInput,
  type WorkQueueTabId,
} from './work-queue.util';

/** Org-wide / polygon totals — jeden počet na druh práce v Navolávání. */
export type NavolavaniEligibleCountsByKind = Record<NavolavaniWorkKind, number>;

export function emptyNavolavaniEligibleCountsByKind(): NavolavaniEligibleCountsByKind {
  return {
    zavrt: 0,
    digitalni_cesta: 0,
    zafuk: 0,
    svar_budovy: 0,
  };
}

/**
 * Zbývá navolat / rezervovat: budova patří do fronty práce pro daný druh
 * a nemá aktivní rezervaci na (object, kind). Uniqueness = work_reservations reserved.
 */
export function isNavolavaniEligibleRemaining(input: {
  building: WorkQueueBuildingInput;
  workKind: WorkReservationKind;
  hasActiveReservation: boolean;
}): boolean {
  if (input.hasActiveReservation) return false;
  const tab = workQueueTabForReservationKind(input.workKind) as WorkQueueTabId;
  return isWorkQueueBuildingMatch(input.building, tab);
}

/** Agregace počtů ze seznamu budov (+ množina objectId s aktivní rezervací per kind). */
export function countNavolavaniEligibleByKind(
  buildings: ReadonlyArray<WorkQueueBuildingInput>,
  reservedObjectIdsByKind: ReadonlyMap<WorkReservationKind, ReadonlySet<string>>,
): NavolavaniEligibleCountsByKind {
  const counts = emptyNavolavaniEligibleCountsByKind();
  for (const kind of NAVOLAVANI_WORK_KINDS) {
    const reserved = reservedObjectIdsByKind.get(kind) ?? new Set<string>();
    let n = 0;
    for (const building of buildings) {
      const objectId = (building.id ?? '').trim();
      if (
        isNavolavaniEligibleRemaining({
          building,
          workKind: kind,
          hasActiveReservation: !!objectId && reserved.has(objectId),
        })
      ) {
        n += 1;
      }
    }
    counts[kind] = n;
  }
  return counts;
}

export function countNavolavaniEligibleForKind(
  buildings: ReadonlyArray<WorkQueueBuildingInput>,
  workKind: WorkReservationKind,
  reservedObjectIds: ReadonlySet<string>,
): number {
  let n = 0;
  for (const building of buildings) {
    const objectId = (building.id ?? '').trim();
    if (
      isNavolavaniEligibleRemaining({
        building,
        workKind,
        hasActiveReservation: !!objectId && reservedObjectIds.has(objectId),
      })
    ) {
      n += 1;
    }
  }
  return n;
}
